var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"rufous white--text"},[(_vm.src)?_c('v-img',{attrs:{"src":_vm.src}}):_vm._e(),(_vm.name)?_c('span',[_vm._v(_vm._s(_vm.name.substr(0, 1)))]):_vm._e(),(_vm.current)?_c('span',[_vm._v(_vm._s((_vm.user ? _vm.user.name : "...").substr(0, 1)))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }